import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './Badge.css';

const cx = classnames.bind(styles);

function Badge({ className, label, variant, iconName }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        [variant]: Boolean(variant)
    });

    return (
        <span className={classes}>
            <Icon name={iconName} />
            {label}
        </span>
    );
}

Badge.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    label: PropTypes.string,
    iconName: PropTypes.string
};

Badge.defaultProps = {
    className: '',
    label: ''
};

export {
    Badge
};
